import { defineMessages } from 'react-intl';

export const carouselMessages = defineMessages({
  infinite: { id: 'Infinite', defaultMessage: 'Infinite' },
  infiniteDesc: {
    id: 'Slide back to start after last item',
    defaultMessage: 'Slide back to start after last item',
  },
  autoplay: { id: 'Autoplay', defaultMessage: 'Autoplay' },
  autoplayOn: { id: 'Enable', defaultMessage: 'Enable' },
  autoplaySpeed: { id: 'Speed', defaultMessage: 'Speed' },
  autoplaySpeedDesc: {
    id: 'Time between items, in seconds',
    defaultMessage: 'Time between items, in seconds',
  },
  layout: { id: 'Layout', defaultMessage: 'Layout' },
  news: { id: 'News', defaultMessage: 'News' },
  gallery: { id: 'Image gallery', defaultMessage: 'Image gallery' },
  // size: { id: 'Size', defaultMessage: 'Size' },
  // small: { id: 'Small', defaultMessage: 'Small' },
  // medium: { id: 'Medium', defaultMessage: 'Medium' },
  // large: { id: 'Large', defaultMessage: 'Large' },
  aspectRatioMobile: {
    id: 'Aspect ratio - Mobile',
    defaultMessage: 'Aspect ratio - Mobile',
  },
  aspectRatioDesktop: {
    id: 'Aspect ratio - Desktop',
    defaultMessage: 'Aspect ratio - Desktop',
  },
});

export const accordionMessages = defineMessages({
  Accordion: {
    id: 'Accordion',
    defaultMessage: 'Accordion',
  },
  AccordionBlock: {
    id: 'Accordion block',
    defaultMessage: 'Accordion block',
  },
  AccordionTitle: {
    id: 'Accordion title',
    defaultMessage: 'Accordion title',
  },
  accordionTitle: {
    id: 'Accordion',
    defaultMessage: 'Accordion',
  },
  Default: {
    id: 'Default',
    defaultMessage: 'Default',
  },
  headline: {
    id: 'Headline',
    defaultMessage: 'Headline',
  },
  Options: {
    id: 'Options',
    defaultMessage: 'Options',
  },
  Title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  friendly_name: {
    id: 'Friendly name',
    defaultMessage: 'Friendly name',
  },
  title_size: {
    id: 'Title size',
    defaultMessage: 'Title size',
  },
  title_size_description: {
    id: 'Accordion Title size',
    defaultMessage: 'Accordion Title size',
  },
  right_arrows: {
    id: 'Title Icon on the right',
    defaultMessage: 'Title Icon on the right',
  },
  right_arrows_description: {
    id: 'When you have nested accordions, it is recomended to uncheck this option',
    defaultMessage:
      'When you have nested accordions, it is recomended to uncheck this option',
  },
  left_arrows: {
    id: 'Title Icon on the left',
    defaultMessage: 'Title Icon on the left',
  },
  left_arrows_description: {
    id: 'When you have nested accordions, it is recomended to check this option',
    defaultMessage:
      'When you have nested accordions, it is recomended to check this option',
  },
  openOnStart: {
    id: 'First panel open',
    defaultMessage: 'First panel open',
  },
  exclusive: {
    id: 'Keep only one item open',
    defaultMessage: 'Keep only one item open',
  },
  exclusive_description: {
    id: 'When opening a panel, all the others will be closed',
    defaultMessage: 'When opening a panel, all the others will be closed',
  },
  groups: {
    id: 'Change layout to highlight hierarchy',
    defaultMessage: 'Change layout to highlight hierarchy',
  },
  groups_description: {
    id: 'Check this option to highlight titles when you have nested accordions',
    defaultMessage:
      'Check this option to highlight titles when you have nested accordions',
  },
  Theme: {
    id: 'Theme',
    defaultMessage: 'Theme',
  },
  ThemeHelp: {
    id: 'Accordion theme',
    defaultMessage: 'Accordion theme',
  },
  ThemePrimary: {
    id: 'Primary',
    defaultMessage: 'Primary',
  },
  ThemeSecondary: {
    id: 'Secondary',
    defaultMessage: 'Secondary',
  },
  ThemeTertiary: {
    id: 'Tertiary',
    defaultMessage: 'Tertiary',
  },
  EnterTitle: {
    id: 'Enter Title',
    defaultMessage: 'Enter Title',
  },
  AddItem: { id: 'Add item', defaultMessage: 'Add item' },
  SectionHelp: {
    id: 'Section help',
    defaultMessage: 'Section help',
  },
});

export const headingMessages = defineMessages({
  left: {
    id: 'Left',
    defaultMessage: 'Left',
  },
  center: {
    id: 'Center',
    defaultMessage: 'Center',
  },
  right: {
    id: 'Right',
    defaultMessage: 'Right',
  },
});

export const columnsMessages = defineMessages({
  useBackground: {
    id: 'useBackground',
    defaultMessage: 'Use gray background',
  },
  backgroundColor: {
    id: 'backgroundColor',
    defaultMessage: 'Background color',
  },
  increasePadding: {
    id: 'increasePadding',
    defaultMessage: 'Increase padding',
  },
  fullWidth: {
    id: 'fullWidth',
    defaultMessage: 'Full width',
  },
  none: {
    id: 'none',
    defaultMessage: 'None',
  },
  background: {
    id: 'background',
    defaultMessage: 'Background',
  },
  contentAndBackground: {
    id: 'contentAndBackground',
    defaultMessage: 'Content and background',
  },
  selectLayout: {
    id: 'Select layout',
    defaultMessage: 'Select layout',
  },
  nColumns: {
    id: 'N columns',
    defaultMessage: '{numCols, plural, one {# column} other {# columns}}',
  },
  equal: {
    id: 'equal',
    defaultMessage: 'equal',
  },
  gray: {
    id: 'gray',
    defaultMessage: 'Gray',
  },
  transparent: {
    id: 'transparent',
    defaultMessage: 'Transparent',
  },
  lightBlue: {
    id: 'lightBlue',
    defaultMessage: 'Light Blue',
  },
});

export const teaserMessages = defineMessages({
  hrefDescription: {
    id: 'teaserHrefDescription',
    defaultMessage:
      'The block will be filled with the data from the selected content.',
  },
  overwrite: {
    id: 'Customize teaser content',
    defaultMessage: 'Customize teaser content',
  },
  overwriteDescription: {
    id: 'The block will update when the target is edited. Check this option to keep the teaser fixed and customize its content.',
    defaultMessage:
      'The block will update when the target is edited. Check this option to keep the teaser fixed and customize its content.',
  },
  // overwriteDescription: {
  //   id: 'Check this option to customize this teaser. Leave it unchecked to display updates from the target content if it is edited later.',
  //   defaultMessage:
  //     'Check this option to customize this teaser. Leave it unchecked to display updates from the target content if it is edited later.',
  // },
  subtitle: {
    id: 'Subtitle',
    defaultMessage: 'Subtitle',
  },
  aspectRatioMobile: {
    id: 'Aspect ratio - Mobile',
    defaultMessage: 'Aspect ratio - Mobile',
  },
  aspectRatioDesktop: {
    id: 'Aspect ratio - Desktop',
    defaultMessage: 'Aspect ratio - Desktop',
  },
  hideDescription: {
    id: 'Hide Description',
    defaultMessage: 'Hide Description',
  },
  hideImage: {
    id: 'Hide Image',
    defaultMessage: 'Hide Image',
  },
  hideSubtitleCategory: {
    id: 'Hide Subtitle',
    defaultMessage: 'Hide Subtitle',
  },
  resetTeaser: {
    id: 'Reset the block',
    defaultMessage: 'Reset the block',
  },
  refreshTeaser: {
    id: 'Refresh source content',
    defaultMessage: 'Refresh source content',
  },
  invalidTeaser: {
    id: 'Invalid teaser source',
    defaultMessage: 'Invalid teaser source',
  },
  verticalAlign: {
    id: 'Vertical align',
    defaultMessage: 'Vertical align',
  },
  horizontalAlign: {
    id: 'Horizontal align',
    defaultMessage: 'Horizontal align',
  },
  imageAlt: {
    id: 'Image description (alt text)',
    defaultMessage: 'Image description (alt text)',
  },
  imageAltDescription: {
    id: 'Describe the purpose of the image. Leave blank if the image is purely decorative.',
    defaultMessage:
      'Describe the purpose of the image. Leave blank if the image is purely decorative.',
  },
  imageAsBackground: {
    id: 'Use image as block background',
    defaultMessage: 'Use image as block background',
  },
  imageAsBackgroundDescription: {
    id: 'When checked, the text will be displayed over the image.',
    defaultMessage: 'When checked, the text will be displayed over the image.',
  },
  Default: {
    id: 'Default',
    defaultMessage: 'Default',
  },
  Image: {
    id: 'Image',
    defaultMessage: 'Image',
  },
  Fields: {
    id: 'Fields',
    defaultMessage: 'Fields',
  },
  Target: {
    id: 'Target',
    defaultMessage: 'Target',
  },
  imageOverride: {
    id: 'Image override',
    defaultMessage: 'Image override',
  },
  openLinkInNewTab: {
    id: 'Open in a new tab',
    defaultMessage: 'Open in a new tab',
  },
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  description: {
    id: 'Description',
    defaultMessage: 'Description',
  },
  head_title: {
    id: 'head_title',
    defaultMessage: 'Head title',
  },
  teaser: {
    id: 'Teaser',
    defaultMessage: 'Teaser',
  },
  align: {
    id: 'Alignment',
    defaultMessage: 'Alignment',
  },
});
